// src/utils/googleSheetsService.js - Version alternative sans CORS

/**
 * Envoie les données vers Google Sheets via un formulaire caché (contourne CORS)
 * @param {Object} formData - Données du formulaire
 * @param {Object} userInfo - Informations utilisateur
 * @returns {Promise} - Résultat de l'envoi
 */
export const sendToGoogleSheets = async (formData, userInfo) => {
  try {
    console.log('Envoi vers Google Sheets du client via formulaire caché...');
    
    const GOOGLE_APPS_SCRIPT_URL = process.env.REACT_APP_GOOGLE_SCRIPT_URL;
    
    // Vérifier que l'URL est configurée
    if (!GOOGLE_APPS_SCRIPT_URL || GOOGLE_APPS_SCRIPT_URL.includes('VOTRE_URL_ICI')) {
      throw new Error('URL Google Apps Script non configurée dans .env');
    }
    
    // Préparer les données à envoyer
    const dataToSend = {
      formData: {
        nom: formData.nom,
        prenom: formData.prenom,
        typeClient: formData.typeClient,
        telephoneContact: formData.telephoneContact,
        email: formData.email,
        dateNaissance: formData.dateNaissance,
        typeIdentite: formData.typeIdentite
      },
      timestamp: new Date().toISOString()
    };

    // Créer un formulaire caché pour contourner CORS
    return new Promise((resolve, reject) => {
      // Créer un iframe caché
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.name = 'google-sheets-frame';
      document.body.appendChild(iframe);
      
      // Créer un formulaire caché
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = GOOGLE_APPS_SCRIPT_URL;
      form.target = 'google-sheets-frame';
      
      // Ajouter les données comme champ caché
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'data';
      input.value = JSON.stringify(dataToSend);
      form.appendChild(input);
      
      // Gérer la réponse
      iframe.onload = () => {
        try {
          setTimeout(() => {
            document.body.removeChild(iframe);
            document.body.removeChild(form);
            console.log('✅ Données envoyées vers Google Sheets avec succès (via formulaire)');
            resolve({ success: true, method: 'form' });
          }, 1000);
        } catch (error) {
          document.body.removeChild(iframe);
          document.body.removeChild(form);
          reject(error);
        }
      };
      
      iframe.onerror = () => {
        document.body.removeChild(iframe);
        document.body.removeChild(form);
        reject(new Error('Erreur lors de l\'envoi vers Google Sheets'));
      };
      
      // Soumettre le formulaire
      document.body.appendChild(form);
      form.submit();
    });

  } catch (error) {
    console.error('❌ Erreur lors de l\'envoi vers Google Sheets:', error);
    throw error;
  }
};

/**
 * Version simplifiée qui envoie seulement vers Google Sheets
 */
export const sendToBothServices = async (formData, userInfo) => {
  try {
    await sendToGoogleSheets(formData, userInfo);
    return {
      googleSheets: { success: true, error: null }
    };
  } catch (error) {
    return {
      googleSheets: { success: false, error: error.message }
    };
  }
};